import { Animated } from 'react-native'

export const animate = (ref: any, animationVal: number) => {
  Animated.timing(ref, {
    toValue: animationVal,
    duration: 300,
    useNativeDriver: true,
  }).start()
}
